import { useFetch } from 'app/queryProvider';
import { TDataFreshness } from '../entities';

export const useDataFreshness = (pathwayId?: string, options?: { enabled?: boolean; refetchInterval?: number }) => {
  return useFetch<TDataFreshness>({
    queryKey: [['pathway', 'data-freshness', pathwayId ?? '']],
    url: '/data-freshness',
    resource: { name: 'pathways', id: pathwayId },
    requireResourceId: true,
    options: {
      refetchInterval: options?.refetchInterval,
      enabled: (options?.enabled ?? true) && !!pathwayId,
    },
  });
};
